import { rei } from "@/services/api"

class MesAnoService {
  static getPdf (data) {
    const options = {
      responseType: 'arraybuffer'
    }

    return rei.post(`relatorios-mes-ano`, data, options).then(res => {
      let blob = new Blob([res.data], { type: 'application/pdf' })
      let url = window.URL.createObjectURL(blob)

      return url
    })
  }
}

export default MesAnoService
